import { render, staticRenderFns } from "./OwnersNewsletterCreate.vue?vue&type=template&id=f47afafa&scoped=true&"
import script from "./OwnersNewsletterCreate.vue?vue&type=script&lang=js&"
export * from "./OwnersNewsletterCreate.vue?vue&type=script&lang=js&"
import style0 from "./OwnersNewsletterCreate.vue?vue&type=style&index=0&id=f47afafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47afafa",
  null
  
)

export default component.exports